import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue';
import { Translator } from 'js/shims-vue';

interface Option {
    value: string;
    label: string;
}

interface Props {
    activeFilter: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineEmailFilters',
  props: {
    activeFilter: {}
  },
  emits: ['filterUpdate'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const $t = inject('$t') as Translator;

const options: Option[] = [
    { value: 'all', label: $t.__('timeline.TimelineEmailFilters.all') },
    { value: 'emailengine.received', label: $t.__('timeline.TimelineEmailFilters.received') },
    { value: 'emailengine.sent', label: $t.__('timeline.TimelineEmailFilters.sended') },
];

const handleChange = (value: string): void => {
    if (value !== '') {
        emit('filterUpdate', [value]);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_CompassSegmentedControl = _resolveComponent("CompassSegmentedControl")!

  return (_openBlock(), _createBlock(_component_CompassSegmentedControl, {
    modelValue: __props.activeFilter[0],
    options: options,
    "onUpdate:modelValue": handleChange
  }, null, 8 /* PROPS */, ["modelValue"]))
}
}

})